// @ts-nocheck

import React, { useMemo } from 'react';

import Formatter from '../../../i18n/formatter';
import { getCurrency } from '../../../i18n/l10n';

type Props = {
  className?: string;
  amount: number;
};

const CurrencyExposant = ({ className, amount }: Props) => {
  const formattedAmount = useMemo(() => {
    const currency = getCurrency();
    return Formatter.formatNumber(amount ?? 0, currency, false, true);
  }, [amount]);
  return <span className={className}>{formattedAmount}</span>;
};

export default CurrencyExposant;
